import clientConfigApi from '../../config/config';
import { globalIV, globalSalt } from '../../config/constant';
import { AesUtil } from '../../JS/AesUtil';


let isFetchingAdhoc = false;

function adjustToHotelGMTOffset(dateString, offset) {
    const date = new Date(dateString.replace('Z', ''));
  
    // Adjust hours and minutes according to the offset
    date.setUTCHours(date.getUTCHours() + offset.hours);
    date.setUTCMinutes(date.getUTCMinutes() + offset.minutes);
  
    return date;
}

const checkShowAdhoc = (props, dataList) => {

    let adHocListData = [];

    const room = localStorage.getItem("room");
    const checkInguestInfo = localStorage.getItem("Set_Current_Logged_In_Guest_Details") && JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"));
    const serverDateTime = props.serverTimeDatePayload.date ? new Date(props.serverTimeDatePayload.date.replace("Z", "")) : new Date();
    const todayDate = props.serverTimeDatePayload.date ? new Date(props.serverTimeDatePayload.date.split("T")[0] + "T00:00:00") : new Date();

    const supportedAdHocList = ["Pop-up Message", "Image", "Native notification (mobile)", "Upsell", "Scheduled Message"]
    const adHocEventShownIDList = JSON.parse(localStorage.getItem("adHocEventShownIDList")) || [];



    const checkShowAdhocEvent = (eventData) => {

        if(!eventData){
            return false;
        }

        const currentDay = props.serverTimeDatePayload.currentDay && props.serverTimeDatePayload.currentDay.toLowerCase() || "";
        const serverDate = new Date(serverDateTime).setHours(0, 0, 0, 0);
    
        for (const shownAdHocData of adHocEventShownIDList) {
            if (shownAdHocData.id === eventData.id && shownAdHocData.triggerType == eventData.type) {

                if(new Date(shownAdHocData.adhocEventShownDate) < serverDate){
                    if (currentDay && eventData.adhocEventWeekDay && Object.keys(eventData.adhocEventWeekDay).length > 0 && eventData.adhocEventWeekDay[currentDay]) {
                        return true;
                    }
                    return false;
                }
                
                return false;
            }
        }

        if(currentDay && eventData.adhocEventWeekDay && Object.keys(eventData.adhocEventWeekDay).length > 0 && !eventData.adhocEventWeekDay[currentDay]){
            return false;
        }
    
        return true;
    }

    dataList.forEach((adhocEventsData) => {

        let adhocEventsList = [];

        if (adhocEventsData.adhocTriggers && adhocEventsData.adhocTriggers.length > 0) {
            adhocEventsData.adhocTriggers.forEach((triggerTypeData) => {
                let updatedAdhocEventsData = { ...adhocEventsData, type: triggerTypeData.triggerType };
        
                if (checkShowAdhocEvent(updatedAdhocEventsData)) {
                    adhocEventsList.push(updatedAdhocEventsData);
                }
            });
        } else {
            if (checkShowAdhocEvent(adhocEventsData)) {
                adhocEventsList.push(adhocEventsData);
            }
        }

        adhocEventsList.forEach((adHocEvent) => {

        adHocEvent.extraParams = JSON.parse(adHocEvent.extraParams);
        if ((supportedAdHocList.includes(adHocEvent.multimediaType))) {

            const adHocEventStartTime = adjustToHotelGMTOffset(adHocEvent.startDate, props.serverTimeDatePayload.gmtOffset);
            const adhocEventEndTime = adjustToHotelGMTOffset(adHocEvent.endDate, props.serverTimeDatePayload.gmtOffset);


            const adHocEventCheckTime = (requiredDate) => {
                let adHocEventShowTime = requiredDate ? requiredDate : (adHocEvent.adhocEventWeekDay && Object.keys(adHocEvent.adhocEventWeekDay).length > 0) ? new Date(serverDateTime) : new Date(adHocEventStartTime);

                if(adHocEvent.extraParams && adHocEvent.extraParams.TIME){
                    const [hours, minutes] = adHocEvent.extraParams.TIME.split(":");
                    adHocEventShowTime.setHours(hours, minutes, 0, 0);

                    if(serverDateTime >= adHocEventShowTime){
                        adHocListData.push(adHocEvent)
                    }
                } else {
                    adHocListData.push(adHocEvent)
                }
            }

            if (adHocEventStartTime <= serverDateTime && serverDateTime <= adhocEventEndTime) {

                if (adHocEvent.type == "Date" || adHocEvent.type == "OTHERS") {

                    adHocEventCheckTime(null);

                } else if (adHocEvent.type == "PRE_CHECK_IN" && (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA") && (!room || room == "null"))) {

                    adHocEventCheckTime(null);
                
                } else if(adHocEvent.type == "POST_PRE_CHECK_IN" && (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA") && (!room || room == "null")) ) {

                    adHocEventCheckTime(null);

                } else if (adHocEvent.type == "GUEST CHECK IN" && room && room != "null") {

                    adHocEventCheckTime(null);

                } else if(adHocEvent.type == "GUEST_STAY" && room && room != "null"){

                    adHocEventCheckTime(null);

                } else if (adHocEvent.type == "POST_CHECK_IN" && room && room != "null") {

                    if(checkInguestInfo && checkInguestInfo[0].checkInDate){
                        const adHocMessageShowDate = new Date(checkInguestInfo[0].checkInDate.split("T")[0] + "T00:00:00");
                        adHocMessageShowDate.setTime(adHocMessageShowDate.getTime() + ((adHocEvent.extraParams.NO_OF_DAYS || 0) *  24 * 60 * 60 * 1000));

                        if(serverDateTime >= adHocMessageShowDate){
                            adHocEventCheckTime(adHocMessageShowDate)
                        }

                    }

                } else if (adHocEvent.type == "PRE_CHECK_OUT" && room && room != "null") {

                    if(checkInguestInfo && checkInguestInfo[0].plannedCheckOutDate){
                        const adHocMessageShowDate = new Date(checkInguestInfo[0].plannedCheckOutDate.split("T")[0] + "T00:00:00");
                        adHocMessageShowDate.setTime(adHocMessageShowDate.getTime() - ((adHocEvent.extraParams.NO_OF_DAYS || 0) * 24 * 60 * 60 * 1000));

                        if(serverDateTime >= adHocMessageShowDate){
                            adHocEventCheckTime(adHocMessageShowDate)
                        }

                    }

                } else if (adHocEvent.type == "BIRTHDAY" && room && room != "null") {

                    if(checkInguestInfo && checkInguestInfo[0].guestProfile.birthday && checkInguestInfo[0].guestProfile.birthday != null){
                        const adHocMessageShowDate = new Date(checkInguestInfo[0].guestProfile.birthday.split("T")[0] + "T00:00:00");

                        if(todayDate == adHocMessageShowDate){
                            adHocEventCheckTime(adHocMessageShowDate)
                        }

                    }

                }
            }
        }
    })
    })



    if (adHocListData.length > 0) {
        
        const sortedAdhocListData = adHocListData.sort((a, b) => a.priority - b.priority);
        props.updateAdhocData(sortedAdhocListData);


        props.showAdhocAction(true);
    }
}



export const fetchAdhoc = async (props) => {

    if (isFetchingAdhoc) {
        return;
    }

    isFetchingAdhoc = true;
    setTimeout(() => {
        isFetchingAdhoc = false;
    }, 3000);


    let aesUtil = new AesUtil(128, 1000);
    let guestDetails = {}

    if(localStorage.getItem("Set_Current_Logged_In_Guest_Details")){
        guestDetails = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0];
    } else if((localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))) {
        let preCheckedInData = JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))));
        if(preCheckedInData.reservationNumber){
            guestDetails = preCheckedInData;
        }
    }


    const config = {
        header: { 
            sessionToken: `${localStorage.getItem("GuestJourneySessionToken")}`,
            reservationNumber: guestDetails.reservationNumber || null,
        }
    };

    const headers = {
        headers: {
            'Content-Type': 'application/json',
        }
    }

    try {
        let data = await clientConfigApi.post(`/adhocEvents/fetch`, config, headers)

        checkShowAdhoc(props, data.data.payload.adhocEventList)
    } catch (error) {
        console.log("Adhoc fetching error")
    } finally {
        isFetchingAdhoc = false;
    }

}